import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-badge',
  templateUrl: 'badge.html',
})
export class BadgePage extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  percent_hat = '20%';
  itemExpandHeight = 250;
  refresh_dashboard: boolean = false;

  constructor(public navCtrl: NavController,public translate:TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.refreshpage();
  }
  refreshpage() {
    this.GetRequest('microjourneyListNew', '1').then(data => {

      //this.mjl = data['MicroJourneyList']['da_iniziare'];

      this.mjl = data['MicroJourneyList'];

      for (let i = 0; i < this.mjl.length; i++) {
        this.mjl[i].arr_expand = false;
        this.mjl[i].badge = [];
      }

      // console.log(this.mjl);
    }).catch((e) => {
      console.error(e)
    })
  }

  back() {
    if (this.refresh_dashboard == false)
      this.navCtrl.pop({ animate: false });
    else
      this.go_root();
  }
  open_badge(i) {


    if (i.arr_expand == false) {
      this.GetRequest('badgeMJ', i.id).then(data => {
        i.badge = data['BadgeList'];
        // console.log(data);
        i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;

  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  reset_badge(item) {
    // console.log(item);
    this.translate.get(['badge.AZZERAPERCORSOCONFIRM', 'badge.AZZERARECONFIRM'], { nome: item.nome }).subscribe(v => {
      this.presentPopover(event, Confirm, v['badge.AZZERAPERCORSOCONFIRM']).then((data) => {
        // console.log(data);
        if (data == 'confirm') {
          this.presentPopover(event, Confirm, v['badge.AZZERARECONFIRM'], 'danger').then((data_) => {
            if (data_ == 'confirm') {
              this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
                this.refresh_dashboard = true;
                // console.log(data_x);
                this.svuota_cache_all_mj(item.id);
                item.arr_expand = false;
              }).catch((e) => {
                //this.navCtrl.push(Mj_Detail,{mj:m});
                console.error(e)
              })
            }
          });
        }
      });
    });

  }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/badge/badge.ts